<app-banner-info [page]="'wip'" [title]="'Sezione in manutenzione'"
    [subtitle]="'I dati saranno disponibili il prima possibile.'">
</app-banner-info>